import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.function.name.js";
import { defineComponent, reactive, ref, watchEffect } from "vue";
import { useRoute } from "vue-router";
export default defineComponent({
  name: "play-list-head",
  props: {
    listTag: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    allTagList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    scrollTopTitle: {
      type: String,
      default: ""
    }
  },
  setup: function setup(props, _ref) {
    var emit = _ref.emit;
    var route = useRoute();
    var isItem = ref("");
    var tagName = ref(props.scrollTopTitle);
    var tageCateName = ref("");
    var tageCateList = reactive([]);
    var allTagList = reactive([]);
    /* 左边分类 */

    var cate = reactive([{
      title: "语种",
      icon: "icon-global"
    }, {
      title: "风格",
      icon: "icon-yinlemoshi"
    }, {
      title: "场景",
      icon: "icon-Cafe"
    }, {
      title: "情感",
      icon: "icon-emoji"
    }, {
      title: "主题",
      icon: "icon-zhuti"
    }]);
    /* 头部标签点击事件 */

    var tagClick = function tagClick(tag, id) {
      /* 发出事件,点击同样不发出 */
      if (tagName.value !== tag) emit("changeTagName", tag, id);
      isItem.value = tag;
      tagName.value = tag;
      tageCateName.value = tag;
    };
    /* 各种标签分类(语种、HOT、风格..) */


    watchEffect(function () {
      //如果poops的allTagList有值
      if (props.allTagList.length !== 0) {
        allTagList = props.allTagList;
        /* 如果有category属性 */

        if (allTagList[0].category) {
          var _loop = function _loop(i) {
            tageCateList.push(allTagList.filter(function (item) {
              return item.category == i;
            }).map(function (item) {
              return {
                name: item.name,
                hot: item.hot
              };
            }));
          };

          /* 各种标签分类(语种、HOT、风格..) */
          for (var i = 0; i < 5; i++) {
            _loop(i);
          }
        } else {
          /* 如果没有则只遍历名字 */
          for (var _i = 0; _i < allTagList.length; _i++) {
            tageCateList.push(allTagList.map(function (item) {
              return item.name;
            }));
          }
        }
      }
    });
    return {
      route: route,
      isItem: isItem,
      tagName: tagName,
      tageCateName: tageCateName,
      cate: cate,
      tageCateList: tageCateList,
      tagClick: tagClick
    };
  },
  components: {}
});